const isScrolledIntoView = (el, completelyVisible = false) => {
  const rect = el.getBoundingClientRect();
  const elemTop = rect.top;
  const elemBottom = rect.bottom;

  let isVisible = false;
  if (completelyVisible) {
    // Only completely visible elements return true:
    isVisible = (elemTop >= 0)
      && (elemBottom <= window.innerHeight); // eslint-disable-line no-undef
  } else {
    // Partially visible elements return true:
    isVisible = elemTop < window.innerHeight // eslint-disable-line no-undef
      && elemBottom >= 0;
  }
  return isVisible;
};

export default isScrolledIntoView;



// WEBPACK FOOTER //
// ./src/utils/isScrolledIntoView.js